import { render } from "./BuscarCtaHabiente.vue?vue&type=template&id=e547b738&scoped=true"
import script from "./BuscarCtaHabiente.vue?vue&type=script&lang=js"
export * from "./BuscarCtaHabiente.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e547b738"]])

export default __exports__